function addGalleryImage(state=[], action) {
    if (action.type === 'ADD_GALLERY_IMAGE') {
        return [ ...state, action.galleryImage ]
    }
    return state;
}
function clearGalleryImages(state = [], action) {
    if (action.type === 'CLEAR_GALLERY_IMAGES') {
        return [];
    }
    return state;
}

function galleryImages(state = [], action) {
    if (!!action.galleryImage) {
        return addGalleryImage(state, action);
    } else {
        return clearGalleryImages(state, action);
    }
}

export default galleryImages;


// WEBPACK FOOTER //
// ./src/reducers/galleryImages.js